import { serializeKeyedSelection, deserializeKeyedSelection } from '../../common/datamodel-utils';
export default {
    bindings: {
        ngModel: '=',
        ngRequired: '=',
        mHelp: '@',
        inputLabel: '@',
        optionsList: '=',
    },
    require: {
        ngModelCtrl: "ngModel",
        form: '^form'
    },
    template: ['$element', '$attrs', TemplateBuilder],
    controller: ['$element', Controller],
    controllerAs: 'vm'
};
function Controller($element) {
    var vm = this;
    this.$onInit = function () {
        vm.isRequired = function () {
            return $element.find('input').attr('required') ? true : false;
        };
        vm.keyedSelections = deserializeKeyedSelection(vm.ngModel);
        vm.onOptionChange = () => {
            vm.ngModel = serializeKeyedSelection(vm.keyedSelections);
        };
    };
}
function TemplateBuilder($element, $attrs) {
    const inputIdBase = ('fld' + $attrs.ngModel + Math.random()).replace(/\W+/g, '');
    let required = '';
    if ($attrs.required !== undefined) {
        required = ' required="required"';
    }
    if ($attrs.ngRequired) {
        required = required.concat(' ng-required="vm.ngRequired"');
    }
    const result = `
<div class="form-group" ng-class="{ \'has-error\' : vm.form.${inputIdBase}.$invalid }">
  <label for="${inputIdBase}" class="control-label col-sm-4 col-md-3" style="padding-top: 0px">{{::vm.inputLabel}}<span ng-if="vm.isRequired()"> *</span></label>
  <input type="hidden" name="${inputIdBase}" id="${inputIdBase}" ng-model="vm.ngModel" ${required} />
  <div class="col-sm-8">
    <div class="checkbox" ng-repeat="option in vm.optionsList.options">
      <label>
        <input id="{{'${inputIdBase}_opt' + $index}}" name="{{'${inputIdBase}_opt' + $index}}" type="checkbox" value="" ng-model="vm.keyedSelections[option.name]" ng-change="vm.onOptionChange(option)" /> {{::option.title || option.name}}
      </label>
    </div>
    <div ng-messages="vm.form.${inputIdBase}.$error" role="alert">
      <p ng-message="required" class="help-block bg-danger">Pakollinen tieto</p>
    </div>
    <p ng-if="vm.mHelp" class="help-block">{{vm.mHelp}}</p>
  </div>
</div>`;
    return result;
}
